import React, { useEffect } from "react"
import Switch from "react-switch"
import { useFormContext } from "react-hook-form"
import PropTypes from "prop-types"
import styled from "styled-components"
import theme from "@src/styles/theme"
const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  .react-switch-handle {
    width: 24px !important;
    height: 24px !important;
    top: 3px !important;
    left: 2px !important;
    filter: drop-shadow(0px 1.5px 3px rgba(16, 24, 40, 0.06))
      drop-shadow(0px 1.5px 4.5px rgba(16, 24, 40, 0.1)) !important;
  }
`

const Label = styled.label`
  font-size: 16px;
  font-weight: 500;
  color: ${props => props.theme.gray900 || "#222"};
`

const InputSwitch = ({ name, label, defaultChecked = false }) => {
  const { setValue, watch, register } = useFormContext()

  useEffect(() => {
    register(name)
    setValue(name, defaultChecked)
  }, [register, setValue, name, defaultChecked])

  const checked = watch(name) ?? defaultChecked

  const handleChange = checked => {
    setValue(name, checked)
  }

  return (
    <SwitchWrapper className="switch-input">
      <Switch
        checked={checked}
        onChange={handleChange}
        offColor={theme.gray100}
        onColor={theme.secondary600}
        uncheckedIcon={false}
        checkedIcon={false}
        boxShadow="0px 1.5px 3px rgba(16, 24, 40, 0.06),
            0px 1.5px 4.5px rgba(16, 24, 40, 0.10)"
        activeBoxShadow="none"
        width={54}
        height={30}
      />
      {label && <Label htmlFor={name}>{label}</Label>}

      <input type="hidden" {...register(name)} value={checked} />
    </SwitchWrapper>
  )
}

InputSwitch.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  defaultChecked: PropTypes.bool,
}

export default InputSwitch
